import { RegimeValues } from 'src/types'

import { Tips } from '../../types/fam-graphql'
import {
  NutritionalPreferences,
  NutritionalWeight,
  OnboardingStepType,
} from '../../types'
import {
  COURSE_COMPOSITION_STEP,
  COURSE_RANGE_STEP,
  DIET_PRACTICE_STEP,
  DRIED_VEGETABLES_FREQUENCY_STEP,
  EXPRESS_STEP,
  FISH_FREQUENCY_STEP,
  FRUITS_VEGETABLES_QUANTITY_STEP,
  MEAT_FREQUENCY_STEP,
  PEOPLE_COUNT_STEP,
  STARCHY_FOODS_FREQUENCY_STEP,
} from '../NutritionalValues'

export const onboardingStepsTransformer = (
  t: any,
  stepsValues?: any,
  weightMessage?: string,
  tips?: Tips
): any => [
  {
    type: OnboardingStepType.INTRODUCTION,
    name: 'introduction',
    title: t('onboarding_step_introduction_title'),
  },
  PEOPLE_COUNT_STEP(t, tips, stepsValues),
  DIET_PRACTICE_STEP(t, tips),
  COURSE_COMPOSITION_STEP(t, tips),
  EXPRESS_STEP(t, tips),
  COURSE_RANGE_STEP(t, tips),
  {
    type: OnboardingStepType.INTERSTITIAL,
    name: 'objectives',
    title: t('onboarding_step_objectives_title'),
    image: {
      src: '/images/onboarding/target.png',
      alt: '',
      height: 342,
      width: 480,
    },
    cta: t('onboarding_step_objectives_cta'),
    texts: (
      <>
        <p className="bold">{t('onboarding_step_objectives_text')}</p>
        <p>{t('onboarding_step_objectives_text2')}</p>
      </>
    ),
  },
  FRUITS_VEGETABLES_QUANTITY_STEP(
    t,
    tips,
    false,
    [RegimeValues.NO_MEAT].includes(
      stepsValues?.[NutritionalPreferences.DIET_PRACTICE] ?? ''
    )
  ),
  STARCHY_FOODS_FREQUENCY_STEP(t, tips),
  DRIED_VEGETABLES_FREQUENCY_STEP(t, tips),
  ...([RegimeValues.NO_FISH, RegimeValues.NO_EGG].includes(
    stepsValues[NutritionalPreferences.DIET_PRACTICE]
  )
    ? []
    : [FISH_FREQUENCY_STEP(t, tips)]),
  ...([
    RegimeValues.NO_MEAT,
    RegimeValues.NO_FISH,
    RegimeValues.NO_EGG,
  ].includes(stepsValues[NutritionalPreferences.DIET_PRACTICE])
    ? []
    : [MEAT_FREQUENCY_STEP(t, tips)]),
  {
    type: OnboardingStepType.INTERSTITIAL,
    name: 'congratulations',
    title: t('onboarding_congratulations_title'),
    cta: t('onboarding_congratulations_cta'),
    image: {
      src: '/images/onboarding/target.png',
      alt: '',
      height: 342,
      width: 480,
    },
    texts: (
      <>
        {weightMessage === NutritionalWeight.MINIMAL &&
          tips?.['minium_title'] && (
            <p className="bold">{tips?.['minium_title']}</p>
          )}
        {weightMessage === NutritionalWeight.MEDIUM &&
          tips?.['medium_title'] && (
            <p className="bold">{tips?.['medium_title']}</p>
          )}
        {weightMessage === NutritionalWeight.OPTIMAL &&
          tips?.['optimal_title'] && (
            <p className="bold">{tips?.['optimal_title']}</p>
          )}
        {weightMessage === NutritionalWeight.MINIMAL && tips?.['minium'] && (
          <p>{tips?.['minium']}</p>
        )}
        {weightMessage === NutritionalWeight.MEDIUM && tips?.['medium'] && (
          <p>{tips?.['medium']}</p>
        )}
        {weightMessage === NutritionalWeight.OPTIMAL && tips?.['optimal'] && (
          <p>{tips?.['optimal']}</p>
        )}
      </>
    ),
  },
  {
    type: OnboardingStepType.GENERATION,
    name: 'generation',
  },
]
